import axios from 'axios';

export default {

    findAllFrontal(ctx) {
        return axios.get(api_url + user_role + "/packs/order-kitchen", {
            params: { ctx: ctx }
        });
    },
    findByCode(pack_code) {
        return axios.get(api_url + user_role + "/packs/order-kitchen-all", {
            params: {
                pack_code: pack_code
            }
        });
    },
    findAllElectros() {
        return axios.get(api_url + user_role + "/packs/products-magento");
    },
    findElectro(sku) {
        return axios.get(api_url + user_role + "/packs/single-product-magento", {
            params: {
                sku: sku
            }
        });
    },
    createProject(params) {
        return axios.post(api_url + user_role + "/packs/create-project", params);
    }
}


// WEBPACK FOOTER //
// ./src/api/packfrontal.js